import React, { useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import style from "src/Assets/css/home/TrendingTagResults.module.css";
import NoDataFound from "src/Assets/images/data-not-found.svg";
import Post from "../components/Post";
import CircularProgress from "@material-ui/core/CircularProgress";
import backwardarrow from "src/Assets/images/backwardarrow.png";

const TrendingTags = (props) => {
  const {
    allTags,
    allTagData,
    goBack,
    loading,
    childSaysLoading,
    postChildSayData,
    fetchFeedData,
    deleteMessage,
    childSaysData,
    fetchChildSaysData,
    fetchFollowData,
    fetchVoteUpStatus,
    refreshFeedData,
    showData,
    hasRestrictionSays,
    fetchContributors,
    onHashTagClick,
    updateTrendingTagPageCount,
    hasMoreTrendingTags,
    isActionDisabled,
    flow,
    onActionSuccess
  } = props;

  const listRef = useRef(null);

  const handleScroll = useCallback(() => {
    const { scrollTop, clientHeight, scrollHeight } = listRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 5 && hasMoreTrendingTags) {
      updateTrendingTagPageCount && updateTrendingTagPageCount();
    }
  }, [hasMoreTrendingTags]);

  if (loading && Array.isArray(allTags) && allTags.length === 0) {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      {allTags && Object.keys(allTags).length > 0 ? (
        <div
          className={style.TagResults}
          ref={listRef}
          // onScroll={handleScroll}
          role="list"
        >
          <div className={style.TagResultContainer}>
            <a>
              <img
                src={backwardarrow}
                onClick={goBack}
                className={style.trendingTagImage}
              />
            </a>
            <span className={style.trendingTagHeading}>Trending TAGs</span>
          </div>
          <Post
            loading={childSaysLoading}
            fetchFeedData={fetchFeedData}
            deleteMessage={deleteMessage}
            listdata={allTags}
            data={allTags}
            allTagData={allTagData}
            postChildSayData={postChildSayData}
            childSaysData={childSaysData}
            fetchChildSaysData={fetchChildSaysData}
            fetchFollowData={fetchFollowData}
            fetchVoteUpStatus={fetchVoteUpStatus}
            refreshFeedData={refreshFeedData}
            showData={showData}
            isTag={true}
            hasRestrictionSays={hasRestrictionSays}
            fetchContributors={fetchContributors}
            onHashTagClick={onHashTagClick}
            isActionDisabled={isActionDisabled}
            flow={flow}
            onActionSuccess={onActionSuccess}
          />
        </div>
      ) : (
        <div className={style.nodata}>
          <img src={NoDataFound} alt="NoDataFound" width="200" />
          <p>No Data Found</p>
        </div>
      )}
    </>
  );
};

export default TrendingTags;
